var map = {
	"./romme.png": 184,
	"./rommeAnniversary.png": 6184,
	"./skat.png": 6379,
	"./skatAnniversary.png": 9860,
	"./skatNewYear.png": 295,
	"./speedSkat.png": 7996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8624;